import axios from '@axios'

const route = 'account/notifications'

export default {
  namespaced: true,
  state: {
    notifications: [],
  },
  getters: {
    getNotifications: state => state.notifications,
  },
  mutations: {
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
  },
  actions: {
    index(context, { page, itemsPerPage, filters }) {
      const pagination = `?page=${page}&items_per_page=${itemsPerPage}`

      return axios.post(route + pagination, filters)
    },
    markAsRead(context, notificationId) {
      return axios.post(`${route}/mark-as-read/${notificationId}`)
    },
    getAllUnread(context) {
      return axios.get(`${route}/unread`)
    },
    getNotification(context, notificationId) {
      return axios.get(`${route}/${notificationId}`)
    },
  },
}
